<div class="cmdp-overlay" *ngIf="isOpen" (click)="close()">
  <div class="cmdp" (click)="$event.stopPropagation()" role="dialog" aria-label="Recherche globale">
    <div class="cmdp__head">
      <span nz-icon [nzType]="isLoading ? 'loading' : 'search'" nzTheme="outline" class="cmdp__icon"></span>
      <input
        #input
        class="cmdp__input"
        [ngModel]="query"
        (ngModelChange)="onQueryChange($event)"
        placeholder="Rechercher une plainte, naviguer…"
        autocomplete="off"
        spellcheck="false"
      />
      <kbd class="cmdp__kbd">Esc</kbd>
    </div>

    <div class="cmdp__results" *ngIf="results.length > 0; else empty">
      <button
        type="button"
        *ngFor="let r of results; let i = index; trackBy: trackByIndex"
        class="cmdp__item"
        [class.is-selected]="i === selectedIndex"
        (click)="execute(r)"
        (mouseenter)="selectedIndex = i"
      >
        <span nz-icon [nzType]="r.icon" nzTheme="outline" class="cmdp__item-icon"></span>
        <span class="cmdp__item-label">{{ r.label }}</span>
        <span class="cmdp__item-hint" *ngIf="r.hint">{{ r.hint }}</span>
        <span class="cmdp__item-type" [class.cmdp__item-type--plainte]="r.type === 'plainte'">
          {{ r.type === 'plainte' ? 'Plainte' : 'Naviguer' }}
        </span>
      </button>
    </div>

    <ng-template #empty>
      <div class="cmdp__empty">
        <span nz-icon nzType="inbox" nzTheme="outline"></span>
        <p>Aucun résultat</p>
      </div>
    </ng-template>

    <div class="cmdp__foot">
      <span><kbd class="cmdp__kbd">↑</kbd><kbd class="cmdp__kbd">↓</kbd> naviguer</span>
      <span><kbd class="cmdp__kbd">↵</kbd> ouvrir</span>
      <span><kbd class="cmdp__kbd">Esc</kbd> fermer</span>
    </div>
  </div>
</div>
